<!-- blocked-users.html -->
<div class="min-h-[200px]">

  <!-- Loading (first page) -->
  <ng-container *ngIf="isLoading && items.length === 0">
    <div class="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      <div *ngFor="let i of [1,2,3,4,5,6,7,8]"
           class="animate-pulse bg-white rounded-2xl p-5 flex flex-col items-center gap-3 shadow-sm">
        <div class="w-20 h-20 rounded-full bg-gray-200"></div>
        <div class="w-28 h-4 rounded bg-gray-200"></div>
        <div class="w-20 h-3 rounded bg-gray-200"></div>
        <div class="w-24 h-8 rounded-full bg-gray-200"></div>
      </div>
    </div>
  </ng-container>

  <!-- Error -->
  <ng-container *ngIf="error && items.length === 0">
    <div class="flex flex-col items-center justify-center py-20 text-center gap-3">
      <p class="text-gray-400 text-sm">{{ error }}</p>
      <button type="button" (click)="loadNextPage()"
        class="rounded-xl bg-[#D31148] px-5 py-2 text-sm font-semibold text-white hover:bg-[#b80e3d] transition-colors">
        Try again
      </button>
    </div>
  </ng-container>

  <!-- Empty -->
  <ng-container *ngIf="!isLoading && !error && allLoaded && items.length === 0">
    <div class="flex flex-col items-center justify-center py-20 text-center gap-2">
      <div class="mb-2 flex h-14 w-14 items-center justify-center rounded-full bg-gray-100">
        <svg class="h-7 w-7 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10" />
          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
        </svg>
      </div>
      <p class="text-gray-500 text-sm font-medium">You haven't blocked anyone.</p>
      <p class="text-gray-400 text-xs">Blocked users only appear here, and only you can see this list.</p>
    </div>
  </ng-container>

  <!-- List -->
  <ng-container *ngIf="items.length > 0">
    <div class="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      @for (item of items; track trackById($index, item)) {
        <div class="profile-card group bg-white rounded-2xl p-5 flex flex-col items-center gap-2 shadow-sm
                     transition-all duration-200 ease-out">

          <img
            [src]="item?.profileImage?.urlMedium ?? item?.profileImage?.urlSmall ?? avatarFallback(item.displayName)"
            [alt]="item.displayName"
            class="w-20 h-20 rounded-full object-cover grayscale-[35%] opacity-90" />

          <div class="text-center mt-1">
            <p class="font-semibold text-gray-900 text-sm leading-tight line-clamp-1">
              {{ item.displayName }}
            </p>
            <p class="text-gray-400 text-xs mt-0.5">&#64;{{ item.userName }}</p>
          </div>

          <button type="button" (click)="promptUnblock(item, $event)"
            [disabled]="actionPendingFor === item._id"
            class="mt-1 rounded-full border border-[#D31148] px-4 py-1.5 text-xs font-semibold text-[#D31148] hover:bg-rose-50 transition-colors disabled:opacity-50">
            {{ actionPendingFor === item._id ? 'Unblocking…' : 'Unblock' }}
          </button>
        </div>
      }
    </div>

    <!-- Load more -->
    <div *ngIf="!allLoaded" class="flex justify-center py-6">
      <button type="button" (click)="loadNextPage()" [disabled]="isLoading"
        class="rounded-xl border border-[#e6e6e6] bg-white px-6 py-2.5 text-sm font-semibold text-gray-700 hover:border-[#D31148] hover:text-[#D31148] transition-colors disabled:opacity-50">
        {{ isLoading ? 'Loading…' : 'Load more' }}
      </button>
    </div>
  </ng-container>

  <app-confirmation-popup [isOpen]="showUnblockConfirm" icon="warning" title="Unblock User"
    message="Are you sure you want to unblock this user? They'll be able to see your profile, message you, and interact with your posts again."
    confirmLabel="Unblock" cancelLabel="Cancel"
    (confirmed)="confirmUnblock()" (cancelled)="cancelUnblockConfirm()"></app-confirmation-popup>

</div>
